import clsx from 'clsx';
import { useEffect, useState } from 'react';
import type { Editor as TiptapEditor } from '@tiptap/react';

import { Editor, type EditorProps } from '@/components/editor';

import styles from './preview-editor-holder.module.scss';

export const PreviewEditorHolder = (props: PreviewEditorHolderProps) => {
  const { inEditMode = false, onSetEditor, editorProps, className } = props;

  const [editor, setEditor] = useState<TiptapEditor | null>(null);

  useEffect(() => {
    onSetEditor?.(editor);
  }, [editor]);

  return (
    <div
      className={clsx(styles.previewEditorHolder, className, {
        [styles.inEditMode]: inEditMode,
      })}
    >
      <Editor
        setEditor={setEditor}
        editable={inEditMode}
        autofocus={inEditMode}
        data-testid="cortex-editor"
        className={styles.previewEditor}
        editorContentClassName={styles.previewEditorContent}
        {...editorProps}
      />
    </div>
  );
};

interface PreviewEditorHolderProps {
  className?: string;
  inEditMode?: boolean;
  editorProps: EditorProps;
  onSetEditor?: (editor: TiptapEditor | null) => void;
}
